import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from '@nano/common/image';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

import { LangComponent } from './lang.component';

@NgModule({
  imports: [CommonModule, ImageModule, NzPopoverModule],
  declarations: [LangComponent],
  exports: [LangComponent]
})
export class LangModule {}
